<template>
  <div style="padding:20px;">
    <el-row>
      <el-col :span="24">
        <el-button
            style="padding: 0; margin: 20px"
            type="text"
            icon="el-icon-back"
            @click="backPrePage()"
        >
          返回
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-form ref="form" :model="form" label-width="150px" :disabled="formLoading">
        <el-row>
          <el-col :span="24">
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="体验营统一价格">
              <el-input size="medium" type="number" v-model="form.camp_price" placeholder="课程ID"
                        style="width:100px"></el-input>
              <span style="color:#909399"></span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider></el-divider>

        <el-row>
          <el-col :span="24">
            <el-form-item label="体验设置">
              <template v-for="(item, index) in form.camp_ids">
                <el-col :span="8" v-bind:key="index">
                  <el-input size="medium" type="number" v-model="item.course_id" placeholder="课程ID"
                            style="width:100px"></el-input>
                  <div class="extend">
                    <div>{{ item.title }}</div>
                    <div>开课时间：{{ item.begin_at }} ~ {{ item.end_at}}</div>
                  </div>
                  <el-button v-bind:key="index" @click="form.camp_ids.splice(index, 1)" type="danger"
                             icon="el-icon-delete" size="medium"></el-button>
                </el-col>
              </template>
              <el-col :span="24">
                <el-button @click="form.camp_ids.push({course_id:'', title: '',begin_at: '', end_at:''})" type="primary"
                           icon="el-icon-plus" size="medium">增加
                </el-button>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" :loading="onSaveLoading" @click="onSave">保存</el-button>
          <el-button @click="backPrePage()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-row>
  </div>
</template>

<script>
import {getInfo, savePageIdInfo} from "@/api/activityCamp";

export default {
  data: function () {
    return {
      id: "",
      info: {},
      form: {
        camp_price:0,
        camp_ids:[],
      },
      ossAction: "",
      formLoading: false,
      onSaveLoading: false
    };
  },
  created: function () {
    this.id = this.$route.query.id;
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.formLoading = true;
      getInfo({
        id: this.id
      }).then(response => {
        this.formLoading = false;
        if(response.data.camp_price == null){
          response.data.camp_price = 0;
        }
        if(response.data.camp_ids == null){
          response.data.camp_ids = [];
        }
        this.form.camp_price = response.data.camp_price;
        this.form.camp_ids = response.data.camp_ids;
      });
    },
    uploadSuccess(value) {
      this.form[value.formName] = value.fileUrl;
    },
    onSave() {
      this.onSaveLoading = true;
      let that = this;
      savePageIdInfo({
        id: this.id,
        form: this.form
      }).then(res => {
        that.onSaveLoading = false;
        if (res.code == 1) {
          that.$message({
            showClose: true,
            duration: 6000,
            message: "保存成功",
            type: "success"
          });

          this.getInfo();
          // that.backPrePage();
        }
      });
    },
    backPrePage() {
      this.$router.go(-1);
    }
  }
};
</script>
<style>
.el-divider--horizontal {
  margin: 0 0 24px 0;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  min-height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 100px;
  min-height: 70px;
  display: block;
}

.extend{
  color:#909399;
  line-height: 20px;
  display: flex;
  flex-direction: column;
}
.extend div{
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
</style>